import React, { useEffect, useState, useCallback } from 'react'

import { Box, Alert, AlertTitle, IconButton, Tooltip } from '@mui/material'

import LoadingButton from '@mui/lab/LoadingButton';

import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';

import AddBotDialog from "./AddBotDialog/index.js"
import ServiceTimeDialog from "./ServiceTimeDialog/index.js"
import AddExceptionsDialog from "./AddExceptionsDialog/index.js"
import AddTemplateDialog from "./AddTemplateDialog/index.js"
import ConfirmationDialog from '../../Dialogs/Confirmation'
import ConfirmationDialogCaptcha from '../../Dialogs/ConfimationDialogCaptcha/index.js';
import useNotification from "../../Notification/index.js";
import Loading from '../../Loading/index.js';
import api from '../../../api.js';
import EditIcon from '@mui/icons-material/Edit';
import DescriptionIcon from '@mui/icons-material/Description';
import BlockIcon from '@mui/icons-material/Block';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import AttachmentsDialog from './AttachmentsDialog/index.js';
import CircleIcon from '@mui/icons-material/Circle';
import GestureIcon from '@mui/icons-material/Gesture';
import AccessTimeIcon from "@mui/icons-material/AccessTime"

import { getSession } from '../../../auth.js';

import './styles.css'
import AddBotDialogOauth from './AddBotDialogOauth/index.js';
import AddSignatureDialog from './AddSignatureDialog/index.js';

const fakePopup = {
  close: () => {}
}


let timeout = 0
let popup = null

const openOauthConnect = async ({provider, scopes, redirect_url, inbound, callback}) => {
	(popup || fakePopup).close()
	const res = await api.get("/api/oauth/embedding/?" +
			new URLSearchParams({
				provider: provider,
				scopes: scopes,
				redirect_url: redirect_url,
				inbound: inbound
			}))

	popup = window.open(
		res.data,
		"_blank",
		"width=500,height=750,noopener=false"
	)

	let stopped = false

	const poll = async () => {
		if (stopped)
			return
		try {
			const res = await api.get("/api/oauth/check_status/")
			if (res.data.status === "SUCCESS") {
				stopped = true
				// TODO: sync google calendar
				useNotification(
					"Sucesso",
					"Email conectado com sucesso.",
					"success"
				)
				callback()
				return
			} else if (res.data.status === 'ERROR'){
				stopped = true
				useNotification(
					"Ops!",
					res.data.message,
					"danger"
				)
			}
			if (popup?.closed)
			  return
		} catch (e) {}
		clearTimeout(timeout)
		timeout = setTimeout(poll, 2000)
	}
	poll()
}

const fetchData = async (setLoading = () => { }, setBots = () => { }) => {
	const enterpriseId = getSession().profile.enterprise.id;
	setLoading(true);
	const res = await api.get(`/api/enterprises/${enterpriseId}/email/`);
	setLoading(false);

	if (res.status !== 200) {
		useNotification(
			'Ops!',
			'Não foi possível encontrar os emails.',
			'danger'
		);
		return
	}

	setBots(res.data)

	const authErrors = res.data.filter(b => !b.enabled && b.re_enable_time === -1)
	if (authErrors.length > 0) {
		const labels = authErrors.map(b => b.from_address || b.imap_username || b.smtp_username).join(', ')
		useNotification(
			'E-mail desconectado!',
			`A caixa ${labels} foi desconectada por erro de autenticação. Edite as credenciais para reconectar.`,
			'danger'
		)
	}
};

const confirmateActivate = async (item, enabled, setLoading, bots, closeModal) => {
	const enterpriseId = getSession().profile.enterprise.id;
	setLoading(true)
	const res = await api.post(`/api/enterprises/${enterpriseId}/email/${item.id}/activate/`, { enabled: enabled })
	setLoading(false)
	if (res.status !== 200) {
		useNotification(
			'Ops!',
			res.data || 'Ocorreu um erro na requisição.',
			'danger'
		);
		return
	}
	const foundbot = bots.find(each => each.id === res.data.id)
	if (foundbot)
		Object.assign(foundbot, res.data)

	closeModal()
}

const Email = ({ enterprise }) => {

	const [loading, setLoading] = useState(false);
	const [bots, setBots] = useState([]);
	const [showAddBot, setShowAddBot] = useState(null)
	const [showAddBotOauth, setShowAddBotOauth] = useState(null)
	const [showAddExceptions, setShowAddExceptions] = useState(null)
	const [showAddTemplate, setShowAddTemplate] = useState(null)
	const [showAddSignature, setShowAddSignature] = useState(null)
	const [showAddAttachments, setShowAddAttachments] = useState(null)
	const [deleteModal, setDeleteModal] = useState(null)
	const [activateModal, setActivateModal] = useState(null)
	const [showServiceTime, setShowServiceTime] = useState(null)
	const [microsoftDecision, setMicrosoftDecision] = useState(false)

	const deleteBot = async (id) => {
		const enterpriseId = getSession().profile.enterprise.id;
		setLoading(true)
		const res = await api.delete(`/api/enterprises/${enterpriseId}/email/${id}/`)
		setLoading(false)
		if (res.status !== 204) {
			useNotification(
				'Ops!',
				'Ocorreu um erro na requisição.',
				'danger'
			);
			return
		}
		setBots(bots.filter((bot) => bot.id != id))
		setDeleteModal(null)
	}

	const addBot = async (data) => {
		const enterpriseId = getSession().profile.enterprise.id;
		const id = data.id
		const validationData = { ...data }
		delete validationData.id

		if (!validationData.inbound && 'imap_username' in validationData)
			delete validationData.imap_username

		let res = null
		setLoading(true)
		if (id === 0)
			res = await api.post(`/api/enterprises/${enterpriseId}/email/`, validationData)
		else
			res = await api.patch(`/api/enterprises/${enterpriseId}/email/${id}/`, validationData)
		setLoading(false)

		if (![200, 201].includes(res.status)) {
			if (res.status === 404) {
				useNotification(
					'Ops!',
					'Não foi possível registrar o email, verifique as suas credenciais.',
					'danger'
				)
			}
			else if (res.status === 403) {
				let message = 'Credenciais IMAP não configuradas corretamente'
				if (res.data === 'Failed to connect on smtp')
					message = 'Credenciais SMTP não configuradas corretamente'
				useNotification(
					'Ops!',
					message,
					'danger'
				)
			}

			else if (res.status === 409) {
				useNotification(
					'Ops!',
					'IMAP já vinculado a outra conta.',
					'danger'
				)
			}
			else {
				useNotification(
					'Ops!',
					'Ocorreu um erro na requisição.',
					'danger'
				)
			}
			return

		}

		const foundbot = bots.find(each => each.id === res.data.id)
		if (foundbot)
			Object.assign(foundbot, res.data)
		else
			setBots([...bots, res.data])

		setShowAddBot(null)
		setShowAddExceptions(null)
		setShowAddTemplate(null)
		setShowAddSignature(null)
	}

	const editConnection = async (data) => {
		const enterpriseId = getSession().profile.enterprise.id;
		const id = data.id
		setLoading(true)
		const res = await api.post(`/api/enterprises/${enterpriseId}/email/${id}/edit_connection/`, data)
		setLoading(false)

		if (res.status !== 200) {
			if (res.status === 403) {
				let message = 'Credenciais IMAP não configuradas corretamente'
				if (res.data === 'Failed to connect on smtp')
					message = 'Credenciais SMTP não configuradas corretamente'
				useNotification('Ops!', message, 'danger')
			} else {
				useNotification('Ops!', res.data || 'Ocorreu um erro na requisição.', 'danger')
			}
			return
		}

		const foundbot = bots.find(each => each.id === res.data.id)
		if (foundbot)
			Object.assign(foundbot, res.data)

		setShowAddBot(null)
		useNotification('Sucesso!', 'Conexão atualizada com sucesso.', 'success')
	}

	useEffect(() => {
		fetchData(setLoading, setBots)
	}, [])

	if (!enterprise?.platforms?.email) {
		return (
			<Box>
				<Alert severity="info">
					Entre em contato com seu gerente de contas para contratar o canal Email - <a href="https://wa.link/0bs73j">Clique aqui.</a>
				</Alert>
			</Box>
		)
	}

	return (
		<Box className="input-settings settings-body">
			<Loading loading={loading} />
			{activateModal &&
				<ConfirmationDialogCaptcha
					title={<Box>{activateModal.enabled ? 'Desativar' : 'Ativar'} {activateModal.imap_username}</Box>}
					open={true}
					captcha={activateModal.enabled ? 'desativar' : 'ativar'}
					description={<Box>Confirma que deseja {activateModal.enabled ? 'desativar' : 'ativar'} a conta de e-mail {activateModal.imap_username}? Para isso, escreva <b>{activateModal.enabled ? 'desativar' : 'ativar'}</b> no campo abaixo.</Box>}
					handleClose={() => setActivateModal(null)}
					handleSubmit={() => confirmateActivate(activateModal, !activateModal.enabled, setLoading, bots, () => setActivateModal(null))}
				/>
			}
			{microsoftDecision && 
				<ConfirmationDialog 
					open={true}
					title={'Leitura automática'}
					description={'Deseja implementar a leitura automática da caixa de entrada?'}
					handleClose={()=>setMicrosoftDecision(false)}
					handleSubmit={() => {setMicrosoftDecision(false); openOauthConnect(
						{
								provider: "MICROSOFT_EMAIL",
								scopes: "offline_access Mail.ReadWrite Mail.Read Mail.Send openid profile email",
								redirect_url: "https://login.microsoftonline.com/common/oauth2/v2.0/authorize",
								inbound: true,
								callback: () => fetchData(setLoading, setBots)
							}
						)}}
							handleNo={() => {setMicrosoftDecision(false);openOauthConnect(
						{
								provider: "MICROSOFT_EMAIL",
								scopes: "offline_access Mail.Send openid profile email",
								redirect_url: "https://login.microsoftonline.com/common/oauth2/v2.0/authorize",
								inbound: false,
								callback: () => fetchData(setLoading, setBots)
							}
						)}}
				/>}
			{showServiceTime && (
				<ServiceTimeDialog
					data={showServiceTime}
					setEmails={setBots}
					enterpriseId={getSession().profile.enterprise.id}
					handleClose={() => setShowServiceTime(null)}
				/>
			)}
			{showAddBot &&
				<AddBotDialog
					data={showAddBot}
					handleClose={() => setShowAddBot(null)}
					submit={addBot}
					onEdit={editConnection}
				/>
			}
			{showAddBotOauth &&
				<AddBotDialogOauth
					data={showAddBotOauth}
					setBots={setBots}
					fetchData={fetchData}
					setLoading={setLoading}
					handleClose={() => setShowAddBotOauth(null)}
				/>
			}
			{showAddExceptions &&
				<AddExceptionsDialog
					data={showAddExceptions}
					handleClose={() => setShowAddExceptions(null)}
					submit={addBot}
				/>
			}
			{showAddTemplate &&
				<AddTemplateDialog
					data={showAddTemplate}
					handleClose={() => setShowAddTemplate(null)}
					submit={addBot}
				/>
			}
			{showAddSignature &&
				<AddSignatureDialog
					data={showAddSignature}
					handleClose={() => setShowAddSignature(null)}
					submit={addBot}
					signature
				/>
			}
			{showAddAttachments &&
				<AttachmentsDialog
					data={showAddAttachments}
					handleClose={() => setShowAddAttachments(null)}
					submit={addBot}
				/>}
			{deleteModal ?
				<ConfirmationDialogCaptcha open={true}
					title="Excluir página."
					description={
						<span>
							Para confirmar a ação, digite: <span style={{ 'fontWeight': 'bold' }}>remover</span> no campo abaixo.</span>}
					handleClose={() => { setDeleteModal(null) }}
					handleSubmit={() => { deleteBot(deleteModal) }}
					captcha={'remover'}
				/> : null
			}
			<Alert className="telegram-info" severity="info">
				<AlertTitle>
					Para saber como integrar o kwik com email <a href="https://instant.getoutline.com/s/kwik-integracoes/doc/integracao-com-e-mail-v5RCr1SG2H" target="_blank">clique aqui.</a>
				</AlertTitle>
				<Box className="push-s-bottom">
					É necessário:
				</Box>
				<Box>
					<p>Uma conta de email.</p>
					<p>Servidor SMTP e IMAP.</p>
				</Box>
				<Box className="push-s-top">
					Você pode adicionar seu email clicando no botão abaixo.
				</Box>
			</Alert>
			{bots.length !== 0 &&
				<>
					<Box className="category-title push-bottom push-top">
						Email(s)
					</Box>
					<Box className="telegram-bots">
						<table>
							{bots.map((item, index) => (
								<tr>
									{item.inbound && item.imap_server && <td>IMAP: {item.imap_username} - SMTP: {item.from_address || item.smtp_username} (entrante e sainte)</td>}
									{!item.inbound && item.smtp_server && <td>SMTP: {item.from_address || item.smtp_username} (somente sainte)</td>}
									{item.inbound && item.tenant_id && <td>Microsoft Exchange: {item.imap_username} (entrante e sainte)</td>}
									{!item.inbound && item.tenant_id && <td>Microsoft Exchange: {item.imap_username} (somente sainte)</td>}
									<td>
										<Tooltip title="Status">
											<IconButton onClick={() => setActivateModal(item)}>
												<CircleIcon sx={{ color: item.enabled === true ? 'green !important' : 'red !important' }} />
											</IconButton>
										</Tooltip>
										<Tooltip title="Horário de Atendimento">
											<IconButton onClick={() => setShowServiceTime(item)}>
												<AccessTimeIcon className="editicon" />
											</IconButton>
										</Tooltip>
										<Tooltip title="Editar conexão">
											<IconButton onClick={() => { setShowAddBot(item) }}>
												<EditIcon className='editicon' />
											</IconButton>
										</Tooltip>
										<Tooltip title="Endereços de e-mail ignorados">
											<IconButton onClick={() => { setShowAddExceptions(item) }}>
												<BlockIcon className='editicon' />
											</IconButton>
										</Tooltip>
										<Tooltip title="Editar template de e-mail">
											<IconButton onClick={() => { setShowAddTemplate(item) }}>
												<DescriptionIcon className='editicon' />
											</IconButton>
										</Tooltip>
										<Tooltip title="Editar assinatura do e-mail">
											<IconButton onClick={() => { setShowAddSignature(item) }}>
												<GestureIcon className='editicon' />
											</IconButton>
										</Tooltip>
										<Tooltip title="Recebimento e envio de anexos">
											<IconButton onClick={() => { setShowAddAttachments(item) }}>
												<AttachFileIcon className='editicon' />
											</IconButton>
										</Tooltip>
										<Tooltip title="Excluir">
											<IconButton onClick={() => setDeleteModal(item.id)}>
												<DeleteIcon />
											</IconButton>
										</Tooltip>
									</td>
								</tr>
							))}
						</table>
					</Box>
				</>
			}
			{bots.length < enterprise.platforms.email_boxes &&
				<Box className="email-add-button">
					<LoadingButton startIcon={<AddIcon />} variant="contained"
						onClick={() => setShowAddBot({})}
					>
						Adicionar IMAP e SMTP
					</LoadingButton>
					{/* <LoadingButton startIcon={<AddIcon />} variant="contained"
						onClick={() => setShowAddBotOauth({})}
					>
						Adicionar Microsoft Exchange Oauth2
					</LoadingButton> */}
					<LoadingButton startIcon={<AddIcon />} variant="contained"
					    onClick={()=>setMicrosoftDecision(true)}
						// onClick={() => openOauthConnect(
						// 			{
						// 					provider: "MICROSOFT_EMAIL",
						// 					scopes: "offline_access Mail.ReadWrite Mail.Read Mail.Send openid profile email",
						// 					redirect_url: "https://login.microsoftonline.com/common/oauth2/v2.0/authorize",
						// 					callback: () => fetchData(setLoading, setBots)
						// 				}
						// 			)}
					>
						Adicionar conta Microsoft
					</LoadingButton>
				</Box>
			}
			{bots.length >= enterprise.platforms.email_boxes &&
				<Box className="email-add-button">
					<LoadingButton startIcon={<AddIcon />} variant="contained"
						onClick={() => setShowAddBot({})}
						disabled={true}
					>
						Adicionar
					</LoadingButton>
					<Alert severity="info">
						Entre em contato com seu gerente de contas para contratar mais caixas de entrada. Caso já tenha adquirido a licença, fale com nosso suporte para liberação.
					</Alert>
				</Box>
			}
		</Box>
	)
}

export default Email
